import React from "react";
import TableViewPage from "./TableViewPage";
import danniMF from "../assets/excel/Danni_MF.xls";

const DanniMFTablePage = () => {
  return (
    <TableViewPage
      excelFile={danniMF}
      title="Финансиране и субсидирани бройки (МФ)"
      headerRow={1}
    />
  );
};

export default DanniMFTablePage;